import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import WarRoomPostPreviewPresenter from '@/components/partials/war-room/WarRoomPostPreviewPresenter/WarRoomPostPreviewPresenter.vue';
import { calculateUpvote, calculateDownvote } from '@/components/partials/war-room/utils';
import { votableTypes } from '@/components/partials/war-room/constants';
import type { IPost } from '@/types/community';

type WarRoomPostPreviewRelatedProps = {
  post: IPost;
  score: number;
  parentPostId: number;
};
type WarRoomPostPreviewRelatedEmits = {
  (event: 'update-post', post: IPost): void;
  (event: 'on-poll-vote', payload: { choiceId: number; post: IPost }): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'WarRoomPostPreviewRelated',
  props: {
    post: null,
    score: null,
    parentPostId: null
  },
  emits: ["update-post", "on-poll-vote"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'update-post', post: IPost): void;
  (event: 'on-poll-vote', payload: { choiceId: number; post: IPost }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  post: IPost;
  score: number;
  parentPostId: number;
};

// TODO: must be merged with WarRoomPostPreview component for prevent code duplication and copy-paste


const { $analytics, $api, $notice, $sentryUtils } = useContext();

async function handleAddVote(value: number): Promise<void> {
  $analytics?.logEvent(`war-room__related-post__rating__set`, { value });
  const { currentRating, nextRating } = calculateUpvote(props.post, value);
  const currentVote = props.post.current_vote;

  const updatedPost = { ...props.post, rating: nextRating, current_vote: value };
  emit('update-post', updatedPost);

  try {
    await $api.$post('/api/war_room/ratings.json', {
      reactable_type: votableTypes.POST,
      reactable_id: props.post.id,
      value,
    });
  } catch (e) {
    const updatedPost = { ...props.post, rating: currentRating, current_vote: currentVote };
    emit('update-post', updatedPost);

    if (e instanceof Error) {
      $notice.error(e);
    }

    $sentryUtils.error(e);
  }
}

async function handleRemoveVote(): Promise<void> {
  $analytics?.logEvent(`war-room__related-post__rating__unset`);
  const { currentRating, nextRating } = calculateDownvote(props.post);
  const currentVote = props.post.current_vote;

  const updatedPost = { ...props.post, rating: nextRating, current_vote: 0 };
  emit('update-post', updatedPost);

  try {
    await $api.$delete(`/api/war_room/ratings?reactable_type=${votableTypes.POST}&reactable_id=${props.post.id}`);
  } catch (e) {
    const updatedPost = { ...props.post, rating: currentRating, current_vote: currentVote };
    emit('update-post', updatedPost);

    if (e instanceof Error) {
      $notice.error(e);
    }

    $sentryUtils.error(e);
  }
}

function handleClick() {
  $analytics?.logEvent('war-room__post__related-post-preview__click', {
    parent_post_id: props.parentPostId,
    child_post_id: props.post.id,
    score: props.score,
  });
}

function handlePollVote(choiceId: number): void {
  emit('on-poll-vote', { choiceId, post: props.post });
}

return { __sfc: true,props, emit, $analytics, $api, $notice, $sentryUtils, handleAddVote, handleRemoveVote, handleClick, handlePollVote, WarRoomPostPreviewPresenter }
}

})